import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { PlantTypeService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PlantTypeCreateDto,
  PlantTypeDto,
  PlantTypeExcelDownloadDto,
  PlantTypeUpdateDto,
} from '../proxy/general/dtos/plant-type';
import { PLANTTYPE_CONFIG, PLANTTYPE_FIELDS } from './plant-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-plant-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PlantTypeService, ConfirmationService],
  templateUrl: './plant-type.html',
  styleUrl: './plant-type.scss',
})
export class PlantType extends BaseCrudComponent<
  PlantTypeDto,
  PlantTypeCreateDto,
  PlantTypeUpdateDto,
  PlantTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PlantTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('PlantType', ids),
  };
  config = PLANTTYPE_CONFIG;
  fields = PLANTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PlantTypeDto): PlantTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PlantType';
  }
}
